import { useEffect } from 'react';

export const usePostMesssage = (cb: (d: any) => void, type: string): void => {
  const handleFrameMessages = (e: any): void => {
    if (!e?.data) return;

    try {
      if (typeof e.data === 'object' && e.data?.type === type) {
        cb(JSON.parse(e.data.value));
      }
    } catch (err) {
      console.warn('Invalid message received:', err, e.data);
    }
  };

  useEffect(() => {
    try {
      if (window?.parent && window?.parent !== window) {
        window.parent.postMessage({ name: 'messageFromWebsiteV5toSkinBuilder' }, '*');
      }
    } catch (err) {
      console.warn('postMessage to parent failed:', err);
    }

    window.addEventListener('message', handleFrameMessages);

    return () => window.removeEventListener('message', handleFrameMessages);
  }, []);
};
